import React from 'react';
import { useTranslation } from 'react-i18next';

const Staff: React.FC = () => {
  const { t } = useTranslation();

  const staffMembers = [
    { name: 'Kie Young', positionKey: 'president', japanese: '会長', accent: 'bg-[#2457a7]' },
    { name: 'Sayuri Anderson', positionKey: 'vicePresident', japanese: '副会長', accent: 'bg-[#d95f75]' },
    { name: 'Megumi Mudrick', positionKey: 'adminAccounting', japanese: '会計・事務', accent: 'bg-[#b28a24]' },
    { name: 'Misako Davis', positionKey: 'marketing', japanese: '広報', accent: 'bg-[#3e7462]' },
  ];

  return (
    <section className="page-section">
      <div className="page-container">
        <div className="page-intro">
          <p className="eyebrow">People behind JAJ</p>
          <h1 className="page-title">{t('staff.title')}</h1>
          <p className="page-description">Meet the volunteers who organize programs, support members, and help Japanese culture thrive in Jacksonville.</p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {staffMembers.map((member, index) => {
            const initials = member.name.split(' ').map((part) => part[0]).join('');
            return (
              <article key={member.name} className="surface group overflow-hidden">
                <div className={`h-1.5 ${member.accent}`} />
                <div className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="flex h-14 w-14 items-center justify-center rounded-full bg-[#eef2f7] text-lg font-extrabold text-[#2457a7] transition group-hover:bg-[#2457a7] group-hover:text-white">
                      {initials}
                    </div>
                    <span className="font-japanese text-2xl font-bold text-[#e6a8b3]">{member.japanese}</span>
                  </div>
                  <p className="mt-12 text-xs font-bold uppercase text-[#d95f75]">0{index + 1}</p>
                  <h2 className="mt-2 text-xl font-extrabold text-[#172033]">{member.name}</h2>
                  <p className="mt-1 text-sm font-semibold text-[#667085]">{t(`staff.positions.${member.positionKey}`)}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Staff;
